export interface PatentLinkRequestType {
    patent_no?: string
    patent_id?: string
}

export interface PatentLinkResponseType {
    pdf_url: string
    patent_no: string
    patent_id: string
}

export interface IPatentLinkApi {
    getPatentLink: (params: PatentLinkRequestType) => Promise<PatentLinkResponseType>
}

export const IPatentLinkApi = Symbol('IPatentLinkApi')
